export const UNKNOWN = 'UNKNOWN';
export const WRH = 'WRH';
export const WRE = 'WRE';
export const WR = 'WR';
